import React, { Component } from "react";
import IncautacionComponent from '../components/IncautacionComponent';
import Landing from '../../landing/containers/LandingContainer';
import { sendService } from "../../Services/service";
import ViewIncautacion from "../components/ViewIncautacion";
import { api_base } from '../../constants/services/api'


import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../Actions/Dashboard';
import * as ModalActs from '../../Actions/Modal';

import "../style.css";


class Incautaciones extends Component {
  state = {
    cant: '',
    getqrs: false,
    operList: [],
    control: { count: 0, page: '0', pages: 0, pageSize: 20 },
    searchError: false,
    search: '',
    loading: false,
    filterIep: '0',
    startDate: '',
    endDate: '',
    ieps: [],
    barrioFilter: [],
    barrio: '0',
  }

  onChangeRoute = (route) => {
    this.props.actions.activePage(route);
    this.props.history.push(route);
  }

  handlerTextPunto = e => {
    if (e.target.value === '') this.setState({ getqrs: false })
    else this.setState({ cant: parseInt(e.target.value), getqrs: true })
  }

  handlerSearch = e => {
    this.setState({
      search: e.target.value,
      searchError: false
    })
  }

  handlerKeyUp = e => {
    if (e.keyCode === 13)
      this.getSearch()
  }

  getSearch = () => {
    this.getPageData()
  }

  componentDidMount() {
    this.getPageData()
  }

  getPageData = (page = 0) => {
    this.setState({ loading: true })
    sendService(`/api/v1/incautacion/getpageable?page=${page}&search=${this.state.search}`, "GET").then(value => {
      this.setState({ operList: value.response.rows, control: value.response.control, loading: false })
    })
  };

  openIncautacion = (id) => {
    sendService(`/api/v1/incautacion/get/${id}`, "GET").then(value => {
      this.props.modalActions.openModal(
        <ViewIncautacion close={this.props.modalActions.closeModal} operData={value.response} onSave={(s) => this.editOper(s)} />
      )
    })

    this.props.modalActions.openModal(
      <div>cargando...</div>
    )
  }

  getPdf = (id) => {
    window.open(`${api_base}/api/v1/incautacion/getPdfDocument/${id}`, '_blank')
  }

  editOper = (data) => {
    this.props.modalActions.closeModal()
    this.props.modalActions.openLoader()
    sendService(`/api/v1/incautacion/edit`, "POST", {
      ...data,
      diasLaborales: data.diasLaborales ? data.diasLaborales.reduce((p, c) => `${p}${c.id}`, '') : ''
    }).then(value => {
      this.props.modalActions.closeLoader()
      if (value.status !== 200) {
        alert('Problemas con la carga de los datos')
      }
    })
  }

  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <IncautacionComponent
          state={this.state}
          session={this.props.session}
          onChangeRoute={this.onChangeRoute}
          handlerTextPunto={this.handlerTextPunto}
          handlerSearch={this.handlerSearch}
          searchKeyUp={this.handlerKeyUp}
          onGetSearch={this.getSearch}
          onOpen={this.openIncautacion}
          onChangePage={this.getPageData}
          onGetPdf={this.getPdf}
        />
      </Landing>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    modalActions: bindActionCreators(ModalActs, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Incautaciones);